import { GsFormSchema } from 'libs/shared/src/components';
import { BASIC_SCHEMA_FIELDS, borderRadiusSchemaFields } from '../basics';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the news-detail component form.
 * Defines the fields to display for the form.
 */
export const NEWS_DETAIL_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'showDate',
      label: 'components.newsDetail.schema.showDate',
      type: 'checkbox',
      default: true,
      nullable: false
    },
    ...borderRadiusSchemaFields('', undefined, false, undefined, 'schema.imageRadius')
  ]
};
